import TextField from "@material-ui/core/TextField";
import ToggleButton from "@mui/material/ToggleButton";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import "react-quill/dist/quill.bubble.css";
import { Card, CardBody, Col, Row } from "reactstrap";
import { withRouter } from "../../withRouter";
import AdminFetchServerData from '../../provider/AdminFetchServerData';
import Utils from "../../provider/Utils";
import store from "../../redux/store";
import SaveButton from "../../component/buttons/SaveButton";
import PtsAlert from "../../component/ptsAlert/PtsAlert";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import "./TermsConditionTemplate.scss";
import Quill from "./quill/Quill";
import Tooltip from "./tooltip/Tooltip";
import CancelIconButton from "../../component/buttons/CancelIconButton";
class TermsConditionTemplate extends Component {
  title = "Terms And Conditions Template Details";
  breadCrumb = [
    {
      pageid: "/aptermsConditionsList",
      uiname: "Terms And Conditions Template List",
    },
    { pageid: "", uiname: "Terms And Conditions Template Details" },
  ];
  header = store.getState().adminHeader.adminHeader;
  constructor(props) {
    super(props);
    let termsConditionTemplateId = props.termsConditionTemplateId;
    let action = props.action;
    if (!action && props.state) {
      action = props.state.action;
      termsConditionTemplateId = props.state.termsConditionTemplateId;
    };
    if (action && (Utils.equalsIgnoreCase(action, "view" || Utils.equalsIgnoreCase(action, "update")))) {
      this.getTemplateDetails(termsConditionTemplateId);
    };

    this.state = {
      action: action,
      message: "",
      version: "",
      anchorEl: null,
      id: termsConditionTemplateId,
      variableList: [],
      description: "",
      viewEmailUid: "",
      copied: false,
      render: false,
      getUpdatePermission: false,
      getDeletePermission: false,
      isStatus: true,
      createdByName: "",
      updatedByName: "",
    };
  }

  getTemplateDetails(termsConditionTemplateId) {
    let postObject = {
      header: this.header,
      termsConditions: { id: termsConditionTemplateId },
    };
    AdminFetchServerData.callPostService("/apTermsConditions/get", postObject)
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          let templateDetails = output.data.termsConditions;

          let getPermission = Utils.getRolePermission(
            output.data.privilegeList
          );
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];

          this.setState({
            render: true,
            id: templateDetails.id,
            message: templateDetails.data,
            isStatus: templateDetails.isactive,
            version: templateDetails.version,
            createdByName: templateDetails.createdbyname,
            updatedByName: templateDetails.updatedbyname,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        }
      })
      .catch((error) => { });
  }

  addTermsConditionTemplateInBackend() {
    let postObject = {
      header: this.header,

      termsConditions: {
        data: this.state.message,
        isactive: this.state.isStatus,
        version: this.state.version,
      },
    };
    AdminFetchServerData.callPostService(
      "/apTermsConditions/create",
      postObject
    )
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let templateDetails = output.data.termsConditions;
          this.getTemplateDetails(templateDetails.id);
          this.setState({
            action: "view",
          })
        }
      })
      .catch((error) => { });
  }
  updateTermsConditionTemplateInBackend() {
    let postObject = {
      header: this.header,

      termsConditions: {
        data: this.state.message,
        isactive: this.state.isStatus,
        version: this.state.version,
        id: this.state.id,
      },
    };
    AdminFetchServerData.callPostService(
      "/apTermsConditions/update",
      postObject
    )
      .then((response) => {
        let output = response;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let templateDetails = output.data.termsConditions;
          this.getTemplateDetails(templateDetails.id);
          this.setState({
            action: "view",
          })
        }
      })
      .catch((error) => { });
  }

  deleteTermsConditionToBackend = () => {
    const postObject = {
      header: this.header,
      termsConditions: {
        id: this.state.id,
      },
    };

    AdminFetchServerData.callPostService(
      "/apTermsConditions/delete",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          this.props.navigate("/aptermsConditionsList");
        } 
      })
      .catch((error) => { });
  };

  clearTemplate(e) {
    this.setState({
      message: "",
      version: "",
    });
  }

  handleMessageChange(value) {
    this.setState({ message: value });
  }

  handleClose(event) {
    this.setState({ anchorEl: null });
  }
  cancelEdit() {
    this.setState({ action: "view", termsConditionTemplateId: this.state.id, })

    // this.props.navigate("/viewTermsCondition", {
    //   state: {
    //     action: "view",
    //     title: "Terms And Conditions Template Details",
    //     termsConditionTemplateId: this.state.id,
    //     pageId: "termsConditionList",
    //   },
    // });
  }

  cancelCreate() {
    this.props.navigate("/aptermsConditionsList");
  }

  viewCancel() {
    this.props.navigate("/aptermsConditionsList");
  }

  editTermsCondition() {
    this.setState({ action: "edit", termsConditionTemplateId: this.state.id, })

    // this.props.navigate("/editTermsCondition", {
    //   state: {
    //     action: "edit",
    //     title: "Terms And Conditions Template Details",
    //     termsConditionTemplateId: this.state.id,
    //   },
    // });
  }
  handleVersionChange(e) {
    this.setState({
      version: e.target.value,
    });
  }

  handleStatusChange(e) {
    this.setState({ isStatus: !this.state.isStatus });
  }
  render() {
    if (this.state.action === "create") {
      return this.createTermsConditionTemplate();
    } else if (this.state.action === "edit") {
      return this.editTermsConditionTemplate();
    } else {
      return this.viewTermsConditionTemplate();
    }
  }
  createTermsConditionTemplate() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
        />
        <Row style={{ position: "relative", margin: "1em" }}>
          <Col md={12} style={{ position: "relative", padding: "5px" }}>
            <ValidatorForm
              ref="form"
              style={{ width: "100%" }}
              onSubmit={this.addTermsConditionTemplateInBackend.bind(this)}
            >
              <Card>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <Row>
                        <Col md={2} className="labelColumn">
                          <label id="notificationFormLabel">
                            Version <span className="asterisk">*</span>
                          </label>
                        </Col>
                        <Col md={6} style={{ margin: "-0.8em" }}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            type="text"
                            required
                            className="form-control"
                            id="name"
                            name="name"
                            autoComplete="off"
                            margin="normal"
                            value={this.state.version}
                            onChange={this.handleVersionChange.bind(this)}
                          // inputProps={{
                          //   style: { textTransform: 'capitalize' },
                          // }}
                          />
                        </Col>
                        <Col md={4}></Col>
                      </Row>

                      <Row>
                        <Col md={2} className="labelColumn">
                          <label id="notificationFormLabel">Body</label>
                        </Col>
                        <Col md={10} style={{ marginTop: "2em" }}>
                          {this.state.variableList.length > 0 && (
                            <p style={{ marginLeft: "0.2em" }}>
                              The following variables has a significance role in
                              composing the email. Please do not change it.
                            </p>
                          )}

                          <Quill
                            text={this.state.message}
                            onChange={this.handleMessageChange.bind(this)}
                            className="templateMessageBox"
                            theme="snow"
                            readOnly={false}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>

                <div style={{ textAlign: "center", padding: "0.5em" }}>
                  <SaveButton type="submit" />
                  &nbsp;
                  <CancelIconButton onClick={(e) => this.cancelCreate()} />
                </div>
              </Card>
            </ValidatorForm>
          </Col>
        </Row>
      </>
    );
  }

  viewTermsConditionTemplate() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            history={this.props.history}
            backCallback={this.viewCancel.bind(this)}
            name={this.title}
            editCallback={this.editTermsCondition.bind(this)}
            deleteCallback={this.deleteTermsConditionToBackend.bind(this)}
            getDeletePermission={this.state.getDeletePermission}
            getUpdatePermission={this.state.getUpdatePermission}
          />
          <Row style={{ position: "relative", margin: "1em" }}>
            <Col
              md={12}
              className="sponsorDetailColumn"
              style={{ position: "relative", padding: "5px" }}
            >
              <Card style={{ height: "100%" }}>
                {/* <CardHeader className="cardHeader">
                  <Row>
                    <Col md={10}>
                      <Label className="cardHeaderTitle">
                        Terms And Conditions Template Details
                      </Label>
                    </Col>
                  </Row>
                </CardHeader> */}
                <CardBody>
                  <Row>
                    <Col md={3} className="labelColumn">
                      <Row>
                        <Col md={4}>
                          <label className="bold">Version:</label>
                        </Col>
                        <Col md={8} style={{ textAlign: "left" }}>
                          {this.state.version}
                        </Col>{" "}
                      </Row>
                    </Col>
                    <Col md={3} className="labelColumn">
                      <Row>
                        <Col md={4} style={{ margin: "auto" }}>
                          <label className="bold"> Status</label>
                        </Col>
                        <Col md={8} style={{ textAlign: "left" }}>
                          {this.state.isStatus === true && (
                            <Tooltip title="Please click EDIT to change status">
                              <span>
                                <ToggleButton
                                  value="Active"
                                  className="ToggleButtonActive"
                                  onChange={this.handleStatusChange.bind(this)}
                                  style={{
                                    background: "#27AE60",
                                    color: "#fff",
                                    height: "25px",
                                    textTransform: "none",
                                  }}
                                  disabled
                                >
                                  Active
                                </ToggleButton>
                              </span>
                            </Tooltip>
                          )}
                          {this.state.isStatus === false && (
                            <Tooltip title="Please click EDIT to change status">
                              <span>
                                <ToggleButton
                                  value="Inactive"
                                  className="ToggleButtonInActive"
                                  onChange={this.handleStatusChange.bind(this)}
                                  style={{
                                    background: "#c7c7c7",
                                    color: "#000",
                                    height: "25px",
                                    textTransform: "none",
                                  }}
                                  disabled
                                >
                                  Inactive
                                </ToggleButton>
                              </span>
                            </Tooltip>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col md={3} className="labelColumn">
                      <Row>
                        <Col md={5}>
                          <label className="bold">Created By:</label>
                        </Col>
                        <Col md={7} style={{ textAlign: "left" }}>
                          {this.state.createdByName
                            ? this.state.createdByName
                            : ""}
                        </Col>{" "}
                      </Row>
                    </Col>
                    <Col md={3} className="labelColumn">
                      <Row>
                        <Col md={6}>
                          <label className="bold">Updated By:</label>
                        </Col>
                        <Col md={6} style={{ textAlign: "left" }}>
                          {this.state.updatedByName
                            ? this.state.updatedByName
                            : ""}
                        </Col>{" "}
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={2} className="labelColumn">
                      <label className="bold"> Body:</label>
                    </Col>
                    <Col md={10}>
                      {" "}
                      {this.state.variableList.length > 0 && (
                        <p style={{ marginLeft: "0.2em" }}>
                          The following variables has a significance role in
                          composing the email. Please do not change it.
                        </p>
                      )}
                      <Row style={{ marginTop: "1em" }}>
                        <Col md={12}>
                          <div style={{ border: "1px solid black" }}>
                            <Quill
                              text={this.state.message}
                              onChange={this.handleMessageChange.bind(this)}
                              className="templateMessageBox"
                              theme="bubble"
                              readOnly={true}
                            />
                          </div>
                          {/* <div dangerouslySetInnerHTML={{ __html: this.state.message }} className="emailBody" /> */}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <div style={{ textAlign: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              style={{ background: "#717373", color: "#fff", margin: "0.5em" }}
              startIcon={<ArrowBackIcon />}
              onClick={(e) => this.viewCancel(e)}
            >
              Back
            </Button>
          </div>
        </>
      );
    }
  }
  editTermsConditionTemplate() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          history={this.props.history}
          name={this.title}
        />
        <Row style={{ position: "relative", margin: "1em" }}>
          <Col md={12} style={{ position: "relative", padding: "5px" }}>
            <ValidatorForm
              ref="form"
              style={{ width: "100%" }}
              onSubmit={this.updateTermsConditionTemplateInBackend.bind(this)}
            >
              <Card>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <Row>
                        <Col md={2} className="labelColumn">
                          <label id="notificationFormLabel">
                            Version <span className="asterisk">*</span>
                          </label>
                        </Col>
                        <Col md={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            type="text"
                            required
                            className="form-control"
                            id="name"
                            name="name"
                            autoComplete="off"
                            margin="normal"
                            value={this.state.version}
                            onChange={this.handleVersionChange.bind(this)}
                          />
                        </Col>
                        <Col md={4} style={{ marginTop: "auto" }}>
                          <Row>
                            <Col md={3} style={{ margin: "auto" }}>
                              <label> Status</label>
                            </Col>
                            <Col md={9} className="statusMember">
                              {this.state.isStatus === true && (
                                <Tooltip title="Please click EDIT to change status">
                                  <span>
                                    <ToggleButton
                                      value="Active"
                                      className="ToggleButtonActive"
                                      onChange={this.handleStatusChange.bind(
                                        this
                                      )}
                                      style={{
                                        background: "#27AE60",
                                        color: "#fff",
                                        height: "25px",
                                        textTransform: "none",
                                      }}
                                    >
                                      Active
                                    </ToggleButton>
                                  </span>
                                </Tooltip>
                              )}
                              {this.state.isStatus === false && (
                                <Tooltip title="Please click EDIT to change status">
                                  <span>
                                    <ToggleButton
                                      value="Inactive"
                                      className="ToggleButtonInActive"
                                      onChange={this.handleStatusChange.bind(
                                        this
                                      )}
                                      style={{
                                        background: "#c7c7c7",
                                        color: "#000",
                                        height: "25px",
                                        textTransform: "none",
                                      }}
                                    >
                                      Inactive
                                    </ToggleButton>
                                  </span>
                                </Tooltip>
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row>
                        <Col md={2} className="labelColumn">
                          <label id="notificationFormLabel">Body</label>
                        </Col>
                        <Col md={10} style={{ marginTop: "2em" }}>
                          {this.state.variableList.length > 0 && (
                            <p style={{ marginLeft: "0.2em" }}>
                              The following variables has a significance role in
                              composing the email. Please do not change it.
                            </p>
                          )}

                          <Quill
                            text={this.state.message}
                            onChange={this.handleMessageChange.bind(this)}
                            className="templateMessageBox"
                            theme="snow"
                            readOnly={false}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>

                <div style={{ textAlign: "center", padding: "0.5em" }}>
                  <SaveButton type="submit" />
                  &nbsp;
                  <CancelIconButton onClick={(e) => this.cancelEdit()} />
                </div>
              </Card>
            </ValidatorForm>
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(TermsConditionTemplate);
